mutation BatchNoteCreate($input: NoteBatchTransactionCreateInput!) {
  noteBatchTransactionCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
      isShared
      entityId
    }
  }
}
